import React, { useCallback, useEffect } from 'react';
import { FacebookIcon, InstagramIcon, MailIcon } from 'lucide-react';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { BenefitsSection } from './components/BenefitsSection';
import { OfferSection } from './components/OfferSection';
import { BonusSection } from './components/BonusSection';
import { ReviewsSection } from './components/ReviewsSection';
import { FaqSection } from './components/FaqSection';
import { initMetaPixel, trackPixelEvent } from './utils/metaPixel';
import { warmConnections, runWhenIdle } from './utils/preload';
import { MAIN_MOCKUP } from './data/content';
const CHECKOUT_URL = 'https://el-secreto-del-mate-perfecto.impultienda.ar/checkout';
export function App() {
  useEffect(() => {
    // Prioriza el primer render: primero se calientan las conexiones,
    // el pixel se carga recién cuando el navegador está libre.
    warmConnections(CHECKOUT_URL, MAIN_MOCKUP);
    runWhenIdle(initMetaPixel);
  }, []);
  const handleBuy = useCallback(() => {
    trackPixelEvent('AddToCart', {
      content_name: 'El Secreto del Mate Perfecto',
      content_type: 'product',
      value: 17,
      currency: 'USD'
    });
    window.location.assign(CHECKOUT_URL);
  }, []);
  return <div className="min-h-full w-full bg-[#E4EFDF]" data-id="element-0" data-mp="5os92t1uy7l">
      <main className="relative mx-auto w-full max-w-phone bg-night font-sans text-ivory" data-id="element-1" data-mp="56mnfkhz7n0">
        <Hero data-id="element-2" data-mp="2zmo6pbra6r3p" />
        <PainSection data-id="element-3" data-mp="2zn6aquk6q9m6" />
        <BenefitsSection data-id="element-4" data-mp="33mowttnqsqql" />
        <OfferSection onBuy={handleBuy} data-id="element-5" data-mp="33lwzadal4ixo" />
        <BonusSection data-id="element-6" data-mp="33mylndx1wrup" />
        <ReviewsSection data-id="element-7" data-mp="38lrnua6w0wfk" />
        <FaqSection data-id="element-8" data-mp="38l8f9k34nke7" />

        <footer className="bg-botanic px-5 py-10 text-center" data-id="element-9" data-mp="38l04pyuh8r66">
          <p className="font-display text-[15px] text-gold" data-id="element-10" data-mp="3dkl0k0ecojeo">
            🧉 El Secreto del Mate Perfecto
          </p>
          <nav aria-label="Redes y contacto" className="mt-4 flex items-center justify-center gap-4" data-id="element-11" data-mp="nwc5m3lqig1j">
            <a href="https://www.facebook.com/profile.php?id=61591809817612" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/40 text-gold transition-colors duration-200 hover:border-gold hover:bg-gold/10" data-id="element-12" data-mp="stkne32z0i29">
              <FacebookIcon aria-hidden="true" className="h-5 w-5" data-id="element-13" data-mp="d3cuxpqygsfi" />
            </a>
            <a href="https://www.instagram.com/sale.un.buen.mate/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/40 text-gold transition-colors duration-200 hover:border-gold hover:bg-gold/10" data-id="element-14" data-mp="85bc95xfyv4k">
              <InstagramIcon aria-hidden="true" className="h-5 w-5" data-id="element-15" data-mp="3qbfztg6r6vwq" />
            </a>
            <a href="mailto:saleunbuenmate@gmail.com" aria-label="Escribinos por correo" className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/40 text-gold transition-colors duration-200 hover:border-gold hover:bg-gold/10" data-id="element-16" data-mp="3ljxtsdpvi54w">
              <MailIcon aria-hidden="true" className="h-5 w-5" data-id="element-17" data-mp="2stpmxi0sf75m" />
            </a>
          </nav>

          <a href="mailto:saleunbuenmate@gmail.com" className="mt-3 inline-block font-sans text-[13px] text-ivory/60 underline decoration-gold/40 underline-offset-4" data-id="element-18" data-mp="18cgc3m4xbphy">
            saleunbuenmate@gmail.com
          </a>

          <p className="mt-4 font-sans text-[12px] leading-relaxed text-ivory/40" data-id="element-19" data-mp="ydqyi5k28r7i">
            Contenido educativo e informativo. No reemplaza el consejo de un
            profesional de la salud.
          </p>
        </footer>
      </main>
    </div>;
}